export const noneValue = 'n/a';
export type NoneValue = typeof noneValue;
export const isNone = (value: string | NoneValue | null): boolean =>
    value === null || value === noneValue;
export const isSome = (value: string | NoneValue | null): value is string =>
    value !== null && value !== noneValue;
export const normalizeNone = (value: string | NoneValue | null): string | null =>
    value === noneValue ? null : value;
